webpackJsonp([35783957827783],{

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(5);
	
	var emptyObject = __webpack_require__(34);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * 
	 *   typed.js - A JavaScript Typing Animation Library
	 *   Author: Matt Boldt <me@mattboldt.com>
	 *   Version: v2.0.8
	 *   Url: https://github.com/mattboldt/typed.js
	 *   License(s): MIT
	 * 
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Typed"] = factory();
		else
			root["Typed"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
		
		var _initializerJs = __webpack_require__(1);
		
		var _htmlParserJs = __webpack_require__(3);
		
		/**
		 * Welcome to Typed.js!
		 * @param {string} elementId HTML element ID _OR_ HTML element
		 * @param {object} options options object
		 * @returns {object} a new Typed object
		 */
		
		var Typed = (function () {
		  function Typed(elementId, options) {
		    _classCallCheck(this, Typed);
		
		    // Initialize it up
		    _initializerJs.initializer.load(this, options, elementId);
		    // All systems go!
		    this.begin();
		  }
		
		  /**
		   * Toggle start() and stop() of the Typed instance
		   * @public
		   */
		
		  _createClass(Typed, [{
		    key: 'toggle',
		    value: function toggle() {
		      this.pause.status ? this.start() : this.stop();
		    }
		
		    /**
		     * Stop typing / backspacing and enable cursor blinking
		     * @public
		     */
		  }, {
		    key: 'stop',
		    value: function stop() {
		      if (this.typingComplete) return;
		      if (this.pause.status) return;
		      this.toggleBlinking(true);
		      this.pause.status = true;
		      this.options.onStop(this.arrayPos, this);
		    }
		
		    /**
		     * Start typing / backspacing after being stopped
		     * @public
		     */
		  }, {
		    key: 'start',
		    value: function start() {
		      if (this.typingComplete) return;
		      if (!this.pause.status) return;
		      this.pause.status = false;
		      if (this.pause.typewrite) {
		        this.typewrite(this.pause.curString, this.pause.curStrPos);
		      } else {
		        this.backspace(this.pause.curString, this.pause.curStrPos);
		      }
		      this.options.onStart(this.arrayPos, this);
		    }
		
		    /**
		     * Destroy this instance of Typed
		     * @public
		     */
		  }, {
		    key: 'destroy',
		    value: function destroy() {
		      this.reset(false);
		      this.options.onDestroy(this);
		    }
		
		    /**
		     * Reset Typed and optionally restarts
		     * @param {boolean} restart
		     * @public
		     */
		  }, {
		    key: 'reset',
		    value: function reset() {
		      var restart = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
		
		      clearInterval(this.timeout);
		      this.replaceText('');
		      if (this.cursor && this.cursor.parentNode) {
		        this.cursor.parentNode.removeChild(this.cursor);
		        this.cursor = null;
		      }
		      this.strPos = 0;
		      this.arrayPos = 0;
		      this.curLoop = 0;
		      if (restart) {
		        this.insertCursor();
		        this.options.onReset(this);
		        this.begin();
		      }
		    }
		
		    /**
		     * Begins the typing animation
		     * @private
		     */
		  }, {
		    key: 'begin',
		    value: function begin() {
		      var _this = this;
		
		      this.typingComplete = false;
		      this.shuffleStringsIfNeeded(this);
		      this.insertCursor();
		      if (this.bindInputFocusEvents) this.bindFocusEvents();
		      this.timeout = setTimeout(function () {
		        // Check if there is some text in the element, if yes start by backspacing the default message
		        if (!_this.currentElContent || _this.currentElContent.length === 0) {
		          _this.typewrite(_this.strings[_this.sequence[_this.arrayPos]], _this.strPos);
		        } else {
		          // Start typing
		          _this.backspace(_this.currentElContent, _this.currentElContent.length);
		        }
		      }, this.startDelay);
		    }
		
		    /**
		     * Called for each character typed
		     * @param {string} curString the current string in the strings array
		     * @param {number} curStrPos the current position in the curString
		     * @private
		     */
		  }, {
		    key: 'typewrite',
		    value: function typewrite(curString, curStrPos) {
		      var _this2 = this;
		
		      if (this.fadeOut && this.el.classList.contains(this.fadeOutClass)) {
		        this.el.classList.remove(this.fadeOutClass);
		        if (this.cursor) this.cursor.classList.remove(this.fadeOutClass);
		      }
		
		      var humanize = this.humanizer(this.typeSpeed);
		      var numChars = 1;
		
		      if (this.pause.status === true) {
		        this.setPauseStatus(curString, curStrPos, true);
		        return;
		      }
		
		      // contain typing function in a timeout humanize'd delay
		      this.timeout = setTimeout(function () {
		        // skip over any HTML chars
		        curStrPos = _htmlParserJs.htmlParser.typeHtmlChars(curString, curStrPos, _this2);
		
		        var pauseTime = 0;
		        var substr = curString.substr(curStrPos);
		        // check for an escape character before a pause value
		        // format: \^\d+ .. eg: ^1000 .. should be able to print the ^ too using ^^
		        // single ^ are removed from string
		        if (substr.charAt(0) === '^') {
		          if (/^\^\d+/.test(substr)) {
		            var skip = 1; // skip at least 1
		            substr = /\d+/.exec(substr)[0];
		            skip += substr.length;
		            pauseTime = parseInt(substr);
		            _this2.temporaryPause = true;
		            _this2.options.onTypingPaused(_this2.arrayPos, _this2);
		            // strip out the escape character and pause value so they're not printed
		            curString = curString.substring(0, curStrPos) + curString.substring(curStrPos + skip);
		            _this2.toggleBlinking(true);
		          }
		        }
		
		        // check for skip characters formatted as
		        // "this is a `string to print NOW` ..."
		        if (substr.charAt(0) === '`') {
		          while (curString.substr(curStrPos + numChars).charAt(0) !== '`') {
		            numChars++;
		            if (curStrPos + numChars > curString.length) break;
		          }
		          // strip out the escape characters and append all the string in between
		          var stringBeforeSkip = curString.substring(0, curStrPos);
		          var stringSkipped = curString.substring(stringBeforeSkip.length + 1, curStrPos + numChars);
		          var stringAfterSkip = curString.substring(curStrPos + numChars + 1);
		          curString = stringBeforeSkip + stringSkipped + stringAfterSkip;
		          numChars--;
		        }
		
		        // timeout for any pause after a character
		        _this2.timeout = setTimeout(function () {
		          // Accounts for blinking while paused
		          _this2.toggleBlinking(false);
		
		          // We're done with this sentence!
		          if (curStrPos === curString.length) {
		            _this2.doneTyping(curString, curStrPos);
		          } else {
		            _this2.keepTyping(curString, curStrPos, numChars);
		          }
		          // end of character pause
		          if (_this2.temporaryPause) {
		            _this2.temporaryPause = false;
		            _this2.options.onTypingResumed(_this2.arrayPos, _this2);
		          }
		        }, pauseTime);
		
		        // humanized value for typing
		      }, humanize);
		    }
		
		    /**
		     * Continue to the next string & begin typing
		     * @param {string} curString the current string in the strings array
		     * @param {number} curStrPos the current position in the curString
		     * @private
		     */
		  }, {
		    key: 'keepTyping',
		    value: function keepTyping(curString, curStrPos, numChars) {
		      // call before functions if applicable
		      if (curStrPos === 0) {
		        this.toggleBlinking(false);
		        this.options.preStringTyped(this.arrayPos, this);
		      }
		      // start typing each new char into existing string
		      // curString: arg, this.el.html: original text inside element
		      curStrPos += numChars;
		      var nextString = curString.substr(0, curStrPos);
		      this.replaceText(nextString);
		      // loop the function
		      this.typewrite(curString, curStrPos);
		    }
		
		    /**
		     * We're done typing all strings
		     * @param {string} curString the current string in the strings array
		     * @param {number} curStrPos the current position in the curString
		     * @private
		     */
		  }, {
		    key: 'doneTyping',
		    value: function doneTyping(curString, curStrPos) {
		      var _this3 = this;
		
		      // fires callback function
		      this.options.onStringTyped(this.arrayPos, this);
		      this.toggleBlinking(true);
		      // is this the final string
		      if (this.arrayPos === this.strings.length - 1) {
		        // callback that occurs on the last typed string
		        this.complete();
		        // quit if we wont loop back
		        if (this.loop === false || this.curLoop === this.loopCount) {
		          return;
		        }
		      }
		      this.timeout = setTimeout(function () {
		        _this3.backspace(curString, curStrPos);
		      }, this.backDelay);
		    }
		
		    /**
		     * Backspaces 1 character at a time
		     * @param {string} curString the current string in the strings array
		     * @param {number} curStrPos the current position in the curString
		     * @private
		     */
		  }, {
		    key: 'backspace',
		    value: function backspace(curString, curStrPos) {
		      var _this4 = this;
		
		      if (this.pause.status === true) {
		        this.setPauseStatus(curString, curStrPos, true);
		        return;
		      }
		      if (this.fadeOut) return this.initFadeOut();
		
		      this.toggleBlinking(false);
		      var humanize = this.humanizer(this.backSpeed);
		
		      this.timeout = setTimeout(function () {
		        curStrPos = _htmlParserJs.htmlParser.backSpaceHtmlChars(curString, curStrPos, _this4);
		        // replace text with base text + typed characters
		        var curStringAtPosition = curString.substr(0, curStrPos);
		        _this4.replaceText(curStringAtPosition);
		
		        // if smartBack is enabled
		        if (_this4.smartBackspace) {
		          // the remaining part of the current string is equal of the same part of the new string
		          var nextString = _this4.strings[_this4.arrayPos + 1];
		          if (nextString && curStringAtPosition === nextString.substr(0, curStrPos)) {
		            _this4.stopNum = curStrPos;
		          } else {
		            _this4.stopNum = 0;
		          }
		        }
		
		        // if the number (id of character in current string) is
		        // less than the stop number, keep going
		        if (curStrPos > _this4.stopNum) {
		          // subtract characters one by one
		          curStrPos--;
		          // loop the function
		          _this4.backspace(curString, curStrPos);
		        } else if (curStrPos <= _this4.stopNum) {
		          // if the stop number has been reached, increase
		          // array position to next string
		          _this4.arrayPos++;
		          // When looping, begin at the beginning after backspace complete
		          if (_this4.arrayPos === _this4.strings.length) {
		            _this4.arrayPos = 0;
		            _this4.options.onLastStringBackspaced();
		            _this4.shuffleStringsIfNeeded();
		            _this4.begin();
		          } else {
		            _this4.typewrite(_this4.strings[_this4.sequence[_this4.arrayPos]], curStrPos);
		          }
		        }
		        // humanized value for typing
		      }, humanize);
		    }
		
		    /**
		     * Full animation is complete
		     * @private
		     */
		  }, {
		    key: 'complete',
		    value: function complete() {
		      this.options.onComplete(this);
		      if (this.loop) {
		        this.curLoop++;
		      } else {
		        this.typingComplete = true;
		      }
		    }
		
		    /**
		     * Has the typing been stopped
		     * @param {string} curString the current string in the strings array
		     * @param {number} curStrPos the current position in the curString
		     * @param {boolean} isTyping
		     * @private
		     */
		  }, {
		    key: 'setPauseStatus',
		    value: function setPauseStatus(curString, curStrPos, isTyping) {
		      this.pause.typewrite = isTyping;
		      this.pause.curString = curString;
		      this.pause.curStrPos = curStrPos;
		    }
		
		    /**
		     * Toggle the blinking cursor
		     * @param {boolean} isBlinking
		     * @private
		     */
		  }, {
		    key: 'toggleBlinking',
		    value: function toggleBlinking(isBlinking) {
		      if (!this.cursor) return;
		      // if in paused state, don't toggle blinking a 2nd time
		      if (this.pause.status) return;
		      if (this.cursorBlinking === isBlinking) return;
		      this.cursorBlinking = isBlinking;
		      if (isBlinking) {
		        this.cursor.classList.add('typed-cursor--blink');
		      } else {
		        this.cursor.classList.remove('typed-cursor--blink');
		      }
		    }
		
		    /**
		     * Speed in MS to type
		     * @param {number} speed
		     * @private
		     */
		  }, {
		    key: 'humanizer',
		    value: function humanizer(speed) {
		      return Math.round(Math.random() * speed / 2) + speed;
		    }
		
		    /**
		     * Shuffle the sequence of the strings array
		     * @private
		     */
		  }, {
		    key: 'shuffleStringsIfNeeded',
		    value: function shuffleStringsIfNeeded() {
		      if (!this.shuffle) return;
		      this.sequence = this.sequence.sort(function () {
		        return Math.random() - 0.5;
		      });
		    }
		
		    /**
		     * Adds a CSS class to fade out current string
		     * @private
		     */
		  }, {
		    key: 'initFadeOut',
		    value: function initFadeOut() {
		      var _this5 = this;
		
		      this.el.className += ' ' + this.fadeOutClass;
		      if (this.cursor) this.cursor.className += ' ' + this.fadeOutClass;
		      return setTimeout(function () {
		        _this5.arrayPos++;
		        _this5.replaceText('');
		
		        // Resets current string if end of loop reached
		        if (_this5.strings.length > _this5.arrayPos) {
		          _this5.typewrite(_this5.strings[_this5.sequence[_this5.arrayPos]], 0);
		        } else {
		          _this5.typewrite(_this5.strings[0], 0);
		          _this5.arrayPos = 0;
		        }
		      }, this.fadeOutDelay);
		    }
		
		    /**
		     * Replaces current text in the HTML element
		     * depending on element type
		     * @param {string} str
		     * @private
		     */
		  }, {
		    key: 'replaceText',
		    value: function replaceText(str) {
		      if (this.attr) {
		        this.el.setAttribute(this.attr, str);
		      } else {
		        if (this.isInput) {
		          this.el.value = str;
		        } else if (this.contentType === 'html') {
		          this.el.innerHTML = str;
		        } else {
		          this.el.textContent = str;
		        }
		      }
		    }
		
		    /**
		     * If using input elements, bind focus in order to
		     * start and stop the animation
		     * @private
		     */
		  }, {
		    key: 'bindFocusEvents',
		    value: function bindFocusEvents() {
		      var _this6 = this;
		
		      if (!this.isInput) return;
		      this.el.addEventListener('focus', function (e) {
		        _this6.stop();
		      });
		      this.el.addEventListener('blur', function (e) {
		        if (_this6.el.value && _this6.el.value.length !== 0) {
		          return;
		        }
		        _this6.start();
		      });
		    }
		
		    /**
		     * On init, insert the cursor element
		     * @private
		     */
		  }, {
		    key: 'insertCursor',
		    value: function insertCursor() {
		      if (!this.showCursor) return;
		      if (this.cursor) return;
		      this.cursor = document.createElement('span');
		      this.cursor.className = 'typed-cursor';
		      this.cursor.innerHTML = this.cursorChar;
		      this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling);
		    }
		  }]);
		
		  return Typed;
		})();
		
		exports['default'] = Typed;
		module.exports = exports['default'];
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
		
		var _defaultsJs = __webpack_require__(2);
		
		var _defaultsJs2 = _interopRequireDefault(_defaultsJs);
		
		/**
		 * Initialize the Typed object
		 */
		
		var Initializer = (function () {
		  function Initializer() {
		    _classCallCheck(this, Initializer);
		  }
		
		  _createClass(Initializer, [{
		    key: 'load',
		
		    /**
		     * Load up defaults & options on the Typed instance
		     * @param {Typed} self instance of Typed
		     * @param {object} options options object
		     * @param {string} elementId HTML element ID _OR_ instance of HTML element
		     * @private
		     */
		
		    value: function load(self, options, elementId) {
		      // chosen element to manipulate text
		      if (typeof elementId === 'string') {
		        self.el = document.querySelector(elementId);
		      } else {
		        self.el = elementId;
		      }
		
		      self.options = _extends({}, _defaultsJs2['default'], options);
		
		      // attribute to type into
		      self.isInput = self.el.tagName.toLowerCase() === 'input';
		      self.attr = self.options.attr;
		      self.bindInputFocusEvents = self.options.bindInputFocusEvents;
		
		      // show cursor
		      self.showCursor = self.isInput ? false : self.options.showCursor;
		
		      // custom cursor
		      self.cursorChar = self.options.cursorChar;
		
		      // Is the cursor blinking
		      self.cursorBlinking = true;
		
		      // text content of element
		      self.elContent = self.attr ? self.el.getAttribute(self.attr) : self.el.textContent;
		
		      // html or plain text
		      self.contentType = self.options.contentType;
		
		      // typing speed
		      self.typeSpeed = self.options.typeSpeed;
		
		      // add a delay before typing starts
		      self.startDelay = self.options.startDelay;
		
		      // backspacing speed
		      self.backSpeed = self.options.backSpeed;
		
		      // only backspace what doesn't match the previous string
		      self.smartBackspace = self.options.smartBackspace;
		
		      // amount of time to wait before backspacing
		      self.backDelay = self.options.backDelay;
		
		      // Fade out instead of backspace
		      self.fadeOut = self.options.fadeOut;
		      self.fadeOutClass = self.options.fadeOutClass;
		      self.fadeOutDelay = self.options.fadeOutDelay;
		
		      // variable to check whether typing is currently paused
		      self.isPaused = false;
		
		      // input strings of text
		      self.strings = self.options.strings.map(function (s) {
		        return s.trim();
		      });
		
		      // div containing strings
		      if (typeof self.options.stringsElement === 'string') {
		        self.stringsElement = document.querySelector(self.options.stringsElement);
		      } else {
		        self.stringsElement = self.options.stringsElement;
		      }
		
		      if (self.stringsElement) {
		        self.strings = [];
		        self.stringsElement.style.display = 'none';
		        var strings = Array.prototype.slice.apply(self.stringsElement.children);
		        var stringsLength = strings.length;
		
		        if (stringsLength) {
		          for (var i = 0; i < stringsLength; i += 1) {
		            var stringEl = strings[i];
		            self.strings.push(stringEl.innerHTML.trim());
		          }
		        }
		      }
		
		      // character number position of current string
		      self.strPos = 0;
		
		      // current array position
		      self.arrayPos = 0;
		
		      // index of string to stop backspacing on
		      self.stopNum = 0;
		
		      // Looping logic
		      self.loop = self.options.loop;
		      self.loopCount = self.options.loopCount;
		      self.curLoop = 0;
		
		      // shuffle the strings
		      self.shuffle = self.options.shuffle;
		      // the order of strings
		      self.sequence = [];
		
		      self.pause = {
		        status: false,
		        typewrite: true,
		        curString: '',
		        curStrPos: 0
		      };
		
		      // When the typing is complete (when not looped)
		      self.typingComplete = false;
		
		      // Set the order in which the strings are typed
		      for (var i in self.strings) {
		        self.sequence[i] = i;
		      }
		
		      // If there is some text in the element
		      self.currentElContent = this.getCurrentElContent(self);
		
		      self.autoInsertCss = self.options.autoInsertCss;
		
		      this.appendAnimationCss(self);
		    }
		  }, {
		    key: 'getCurrentElContent',
		    value: function getCurrentElContent(self) {
		      var elContent = '';
		      if (self.attr) {
		        elContent = self.el.getAttribute(self.attr);
		      } else if (self.isInput) {
		        elContent = self.el.value;
		      } else if (self.contentType === 'html') {
		        elContent = self.el.innerHTML;
		      } else {
		        elContent = self.el.textContent;
		      }
		      return elContent;
		    }
		  }, {
		    key: 'appendAnimationCss',
		    value: function appendAnimationCss(self) {
		      var cssDataName = 'data-typed-js-css';
		      if (!self.autoInsertCss) {
		        return;
		      }
		      if (!self.showCursor && !self.fadeOut) {
		        return;
		      }
		      if (document.querySelector('[' + cssDataName + ']')) {
		        return;
		      }
		
		      var css = document.createElement('style');
		      css.type = 'text/css';
		      css.setAttribute(cssDataName, true);
		
		      var innerCss = '';
		      if (self.showCursor) {
		        innerCss += '\n        .typed-cursor{\n          opacity: 1;\n        }\n        .typed-cursor.typed-cursor--blink{\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      ';
		      }
		      if (self.fadeOut) {
		        innerCss += '\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n        }\n        .typed-cursor.typed-cursor--blink.typed-fade-out{\n          -webkit-animation: 0;\n          animation: 0;\n        }\n      ';
		      }
		      if (css.length === 0) {
		        return;
		      }
		      css.innerHTML = innerCss;
		      document.body.appendChild(css);
		    }
		  }]);
		
		  return Initializer;
		})();
		
		exports['default'] = Initializer;
		var initializer = new Initializer();
		exports.initializer = initializer;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		/**
		 * Defaults & options
		 * @returns {object} Typed defaults & options
		 * @public
		 */
		
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		var defaults = {
		  /**
		   * @property {array} strings strings to be typed
		   * @property {string} stringsElement ID of element containing string children
		   */
		  strings: ['These are the default values...', 'You know what you should do?', 'Use your own!', 'Have a great day!'],
		  stringsElement: null,
		
		  /**
		   * @property {number} typeSpeed type speed in milliseconds
		   */
		  typeSpeed: 0,
		
		  /**
		   * @property {number} startDelay time before typing starts in milliseconds
		   */
		  startDelay: 0,
		
		  /**
		   * @property {number} backSpeed backspacing speed in milliseconds
		   */
		  backSpeed: 0,
		
		  /**
		   * @property {boolean} smartBackspace only backspace what doesn't match the previous string
		   */
		  smartBackspace: true,
		
		  /**
		   * @property {boolean} shuffle shuffle the strings
		   */
		  shuffle: false,
		
		  /**
		   * @property {number} backDelay time before backspacing in milliseconds
		   */
		  backDelay: 700,
		
		  /**
		   * @property {boolean} fadeOut Fade out instead of backspace
		   * @property {string} fadeOutClass css class for fade animation
		   * @property {boolean} fadeOutDelay Fade out delay in milliseconds
		   */
		  fadeOut: false,
		  fadeOutClass: 'typed-fade-out',
		  fadeOutDelay: 500,
		
		  /**
		   * @property {boolean} loop loop strings
		   * @property {number} loopCount amount of loops
		   */
		  loop: false,
		  loopCount: Infinity,
		
		  /**
		   * @property {boolean} showCursor show cursor
		   * @property {string} cursorChar character for cursor
		   * @property {boolean} autoInsertCss insert CSS for cursor and fadeOut into HTML <head>
		   */
		  showCursor: true,
		  cursorChar: '|',
		  autoInsertCss: true,
		
		  /**
		   * @property {string} attr attribute for typing
		   * Ex: input placeholder, value, or just HTML text
		   */
		  attr: null,
		
		  /**
		   * @property {boolean} bindInputFocusEvents bind to focus and blur if el is text input
		   */
		  bindInputFocusEvents: false,
		
		  /**
		   * @property {string} contentType 'html' or 'null' for plaintext
		   */
		  contentType: 'html',
		
		  /**
		   * All typing is complete
		   * @param {Typed} self
		   */
		  onComplete: function onComplete(self) {},
		
		  /**
		   * Before each string is typed
		   * @param {number} arrayPos
		   * @param {Typed} self
		   */
		  preStringTyped: function preStringTyped(arrayPos, self) {},
		
		  /**
		   * After each string is typed
		   * @param {number} arrayPos
		   * @param {Typed} self
		   */
		  onStringTyped: function onStringTyped(arrayPos, self) {},
		
		  /**
		   * During looping, after last string is typed
		   * @param {Typed} self
		   */
		  onLastStringBackspaced: function onLastStringBackspaced(self) {},
		
		  /**
		   * Typing has been stopped
		   * @param {number} arrayPos
		   * @param {Typed} self
		   */
		  onTypingPaused: function onTypingPaused(arrayPos, self) {},
		
		  /**
		   * Typing has been started after being stopped
		   * @param {number} arrayPos
		   * @param {Typed} self
		   */
		  onTypingResumed: function onTypingResumed(arrayPos, self) {},
		
		  /**
		   * After reset
		   * @param {Typed} self
		   */
		  onReset: function onReset(self) {},
		
		  /**
		   * After stop
		   * @param {number} arrayPos
		   * @param {Typed} self
		   */
		  onStop: function onStop(arrayPos, self) {},
		
		  /**
		   * After start
		   * @param {number} arrayPos
		   * @param {Typed} self
		   */
		  onStart: function onStart(arrayPos, self) {},
		
		  /**
		   * After destroy
		   * @param {Typed} self
		   */
		  onDestroy: function onDestroy(self) {}
		};
		
		exports['default'] = defaults;
		module.exports = exports['default'];
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		
		/**
		 * TODO: These methods can probably be combined somehow
		 * Parse HTML tags & HTML Characters
		 */
		
		'use strict';
		
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		
		var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
		
		var HTMLParser = (function () {
		  function HTMLParser() {
		    _classCallCheck(this, HTMLParser);
		  }
		
		  _createClass(HTMLParser, [{
		    key: 'typeHtmlChars',
		
		    /**
		     * Type HTML tags & HTML Characters
		     * @param {string} curString Current string
		     * @param {number} curStrPos Position in current string
		     * @param {Typed} self instance of Typed
		     * @returns {number} a new string position
		     * @private
		     */
		
		    value: function typeHtmlChars(curString, curStrPos, self) {
		      if (self.contentType !== 'html') return curStrPos;
		      var curChar = curString.substr(curStrPos).charAt(0);
		      if (curChar === '<' || curChar === '&') {
		        var endTag = '';
		        if (curChar === '<') {
		          endTag = '>';
		        } else {
		          endTag = ';';
		        }
		        while (curString.substr(curStrPos + 1).charAt(0) !== endTag) {
		          curStrPos++;
		          if (curStrPos + 1 > curString.length) {
		            break;
		          }
		        }
		        curStrPos++;
		      }
		      return curStrPos;
		    }
		
		    /**
		     * Backspace HTML tags and HTML Characters
		     * @param {string} curString Current string
		     * @param {number} curStrPos Position in current string
		     * @param {Typed} self instance of Typed
		     * @returns {number} a new string position
		     * @private
		     */
		  }, {
		    key: 'backSpaceHtmlChars',
		    value: function backSpaceHtmlChars(curString, curStrPos, self) {
		      if (self.contentType !== 'html') return curStrPos;
		      var curChar = curString.substr(curStrPos).charAt(0);
		      if (curChar === '>' || curChar === ';') {
		        var endTag = '';
		        if (curChar === '>') {
		          endTag = '<';
		        } else {
		          endTag = '&';
		        }
		        while (curString.substr(curStrPos - 1).charAt(0) !== endTag) {
		          curStrPos--;
		          if (curStrPos < 0) {
		            break;
		          }
		        }
		        curStrPos--;
		      }
		      return curStrPos;
		    }
		  }]);
		
		  return HTMLParser;
		})();
		
		exports['default'] = HTMLParser;
		var htmlParser = new HTMLParser();
		exports.htmlParser = htmlParser;
	
	/***/ })
	/******/ ])
	});
	;

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	__webpack_require__(332);
	
	var _typed = __webpack_require__(437);
	
	var _typed2 = _interopRequireDefault(_typed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Slider component.
	 *
	 * @returns {*}
	 * @constructor
	 */
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Slider.prototype.componentDidMount = function componentDidMount() {
	    //Setting up typed options
	    var options = {
	      strings: ["a frontend developer", "a javascript enthusiast", "a design admirer", "a football addict", "a geek"],
	      typeSpeed: 80,
	      backSpeed: 40,
	      startDelay: 20,
	      backDelay: 2000,
	      loop: true
	    };
	
	    //Creating typed instance
	    var typed = new _typed2.default(".slider__text--hightligted", options);
	  };
	
	  Slider.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "slider" },
	      React.createElement(
	        "h1",
	        { className: "slider__text" },
	        "Hello, I\u2019m ",
	        React.createElement("span", { className: "slider__text--hightligted" }),
	        " based in Warsaw, Poland"
	      )
	    );
	  };
	
	  return Slider;
	}(React.Component);
	
	/** PropTypes */
	
	
	Slider.propTypes = {};
	
	exports.default = Slider;
	module.exports = exports["default"];

/***/ }),

/***/ 332:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Slider = __webpack_require__(203);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(_Slider2.default, null);
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9ca25b5fe2094b0fa400.js